import { Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
import { wrappingAlertSx } from '../../lib/alertLayout';

/** Clearly labels the read-only sample results preview everywhere it shows, with a way out. */
export function SampleDataBanner() {
  const navigate = useNavigate();
  const useMockData = useAuthStore((s) => s.useMockData);
  const isEmbedded = useAuthStore((s) => s.isEmbedded);
  const setUseMockData = useAuthStore((s) => s.setUseMockData);
  if (!useMockData || isEmbedded) return null;
  return (
    <Alert
      severity="info"
      variant="filled"
      data-testid="sample-data-banner"
      sx={{ borderRadius: 0, ...wrappingAlertSx }}
      action={(
        <Button
          color="inherit"
          size="small"
          variant="outlined"
          onClick={() => {
            setUseMockData(false);
            navigate('/dashboard');
          }}
        >
          Exit sample preview
        </Button>
      )}
    >
      Sample results: you&apos;re previewing made-up surveys and responses. Nothing here is your data, and it&apos;s read-only.
    </Alert>
  );
}

/** Mock survey whose results the "Preview with sample results" buttons open. */
export const SAMPLE_PREVIEW_SURVEY_ID = 'mock_survey_product_nps';
